// AuthContext.tsx
import React, { createContext, useContext, useState } from "react";
import { KEY_ACCESS_TOKEN_NAME } from "../constants";

interface AuthContextType {
  isAuthenticated: boolean;
  login: (access_token: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    !!localStorage.getItem(KEY_ACCESS_TOKEN_NAME) || false
  );

  const login = (access_token: string) => {
    localStorage.setItem(KEY_ACCESS_TOKEN_NAME, access_token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem(KEY_ACCESS_TOKEN_NAME);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
